import Application from "../../Application";
import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";
import { IReportingPeriod } from "../../model/reporting/ReportingPeriod";

export default class UpdateReportingPeriodInteractor {
  private application: Application;
  private reportingPeriodService: IReportingPeriodService;

  constructor(application, reportingPeriodService) {
    this.application = application;
    this.reportingPeriodService = reportingPeriodService;
  }

  async execute(reportingPeriod: IReportingPeriod) {
    return this.reportingPeriodService.updateReportingPeriod(reportingPeriod);
  }
}
